import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@environment';
import { NextActionResponse } from '../donate-form/donate-form.model';

@Component({
  selector: 'app-swiss-next-action',
  templateUrl: './swiss-next-action.component.html',
  styleUrls: ['./swiss-next-action.component.scss'],
  standalone: false,
})
export class SwissNextActionComponent implements OnInit {
  @Input() nextAction: NextActionResponse;
  email: string;

  constructor() {}

  ngOnInit(): void {
    this.email = environment.fund.mailTo;
  }

  goToUrl(url: string) {
    window.open(url, '_target');
  }
}
